var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.estaNaRotaDeAcessoNegado)?_c('Header'):_vm._e(),_c('router-view'),(_vm.executingSAMLLogin)?_c('div',{staticClass:"sso-loading"},[_c('h1',[_vm._v("Realizando login por SSO...")])]):_vm._e(),(!_vm.estaNaRotaDeAcessoNegado)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }